// @core/api/endpoints/task/delete_custom_field_definition.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/task';

/**
 * Delete custom field
 * Deletes a custom field definition and all associated values on tasks.
 */
export async function DeleteCustomFieldDefinition(
  field_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/custom-fields/:field_id`;
  requestPath = requestPath.replace(':field_id', encodeURIComponent(field_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
